import './message-license-modal.scss';

import { Box, Stack } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';

import { DialogLayout } from '../../presentation/components/dialog-layout';
import { ILicenseData } from './producer-brokerage-info';
import { NewConvergeButton } from '../../presentation/components/new-button';

interface AddLicenseModalProps {
  onClose: () => void;
  licenseSubmitHandler: () => void;
  title: string;
  setLicenseData?: Dispatch<SetStateAction<ILicenseData[]>>;
  submitLabel: string;
  context: string;
}

export const LicenseModal = ({
  onClose,
  title,
  submitLabel,
  context,
  licenseSubmitHandler,
}: AddLicenseModalProps) => {
  return (
    <DialogLayout
      sx={{
        minWidth: '600px',
        '& .MuiPaper-root.MuiDialog-paper': {
          maxWidth: '600px',
          minWidth: '600px',
          overflow: 'hidden',
        },
      }}
      open
      data-testid="message-license-modal"
      onClose={onClose}
      showCloseButton={true}
      onCloseIconClick={onClose}
      header={<Box className="modal-title-message-license"> {title}</Box>}
    >
      <Stack className="content-message-license">{context}</Stack>
      <Stack className="modal-btn-container-message-license">
        <Box style={{ marginRight: '15px' }}>
          <NewConvergeButton
            data-testid="cancel-button"
            label="CANCEL"
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          />
        </Box>
        <Box>
          <NewConvergeButton
            data-testid="submit-button"
            label={submitLabel}
            onClick={licenseSubmitHandler}
          />
        </Box>
      </Stack>
    </DialogLayout>
  );
};
